"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Twitter, Linkedin, Globe, ShieldCheck } from "lucide-react";
function FooterTopNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6 animate-pulse">
        <div className="h-4 w-16 bg-muted rounded-sm" />
        <div className="h-4 w-20 bg-muted rounded-sm" />
        <div className="h-4 w-14 bg-muted rounded-sm" />
      </div>;
  }
  return <nav className="flex flex-wrap gap-6 md:gap-8">
      {menuItems.map((item, i) => <div key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors tracking-wide uppercase">
            {item.label}
          </Link>
        </div>)}
    </nav>;
}
export default function InstitutionalFooter() {
  const currentYear = new Date().getFullYear();
  const serviceColumns = [{
    title: "Real Estate Capital",
    links: [{
      label: "Rental Portfolio Financing",
      href: "/RealEstateCapitalPage"
    }, {
      label: "Bridge & Transitional",
      href: "/RealEstateCapitalPage"
    }, {
      label: "Fix & Flip Capital",
      href: "/RealEstateCapitalPage"
    }, {
      label: "Construction & Development",
      href: "/RealEstateCapitalPage"
    }]
  }, {
    title: "Business Funding",
    links: [{
      label: "Working Capital Solutions",
      href: "/BusinessCapitalPage"
    }, {
      label: "Structured Term Loans",
      href: "/BusinessCapitalPage"
    }, {
      label: "Growth Equity",
      href: "/BusinessCapitalPage"
    }, {
      label: "Equipment Financing",
      href: "/BusinessCapitalPage"
    }]
  }, {
    title: "Private Credit",
    links: [{
      label: "Institutional Capital",
      href: "/CreditProtectionPage"
    }, {
      label: "Private Credit Networks",
      href: "/CreditProtectionPage"
    }, {
      label: "Mezzanine Financing",
      href: "/CreditProtectionPage"
    }, {
      label: "Distressed Asset Funding",
      href: "/CreditProtectionPage"
    }]
  }, {
    title: "Company & Protection",
    links: [{
      label: "About DynEstate®",
      href: "/AboutPage"
    }, {
      label: "Credit Protection (VSI/LSI)",
      href: "/CreditProtectionPage"
    }, {
      label: "Contact & Support",
      href: "/ContactPage"
    }, {
      label: "Privacy Notice",
      href: "https://docs.google.com/document/d/e/2PACX-1vR1ipE3m5KnwPABTCIxTjqEoT1MX1FLFKl2lmvN3ebUJ7EBaI1daKTORPz_oISByV7QMCLz-RED7D8Z/pub"
    }]
  }];
  return <footer id="institutional-footer" className="dark bg-background text-foreground border-t border-border">
      <div className="container mx-auto px-6 py-12 md:py-16 lg:py-20">
        
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-12">
          <div className="shrink-0">
            <img src="/img/dynestate_logo_transparent-e1772856656558.png" alt="DynEstate®" className="w-auto object-contain !h-[150px]" />
          </div>
          
          <MenuProvider menu_id="45" className="w-full md:w-auto">
            <FooterTopNav />
          </MenuProvider>
        </div>

        <Separator className="bg-border/40 mb-12" />

        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          {serviceColumns.map((column, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
              <h4 className="text-sm font-semibold text-foreground tracking-wider uppercase border-l-2 border-primary pl-3">
                {column.title}
              </h4>
              <ul className="flex flex-col gap-3 pl-3.5">
                {column.links.map((link, j) => <li key={j} data-index={j}>
                    <Link to={link.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors block py-0.5">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <Separator className="bg-border/40 mb-10" />

        
        <div className="flex flex-col lg:flex-row justify-between items-end lg:items-start gap-10">
          
          
          <div className="w-full lg:max-w-3xl space-y-4">
            <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 text-[11px] text-muted-foreground font-sans tracking-tight">
              <span className="uppercase tracking-wider text-foreground/80 font-medium">
                VA Limited Lines Credit Insurance Producer
              </span>
              <span className="hidden sm:inline text-border">|</span>
              <span>License #1555036</span>
              <span className="hidden sm:inline text-border">|</span>
              <span>Exp. 09/30/2028</span>
            </div>
            
            <p className="text-[11px] leading-relaxed text-muted-foreground/80 font-sans max-w-2xl">Dynestate Enterprise LLC is not a bank or direct lender. Dynestate Enterprise LLC structures and delivers financing through its capital marketplace, aligned directly with institutional and private capital partners. The firm operates as an independent capital marketplace and advisor and may receive compensation. All approvals, rates, and terms are subject to underwriting and applicant qualifications. Business-purpose financing only. Loan qualifications, rates, terms, and documentation requirements vary based on lender criteria, transaction structure, borrower profile, and market conditions</p>

            <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 pt-2">
              <div className="flex items-center gap-6">
                <Link to="https://docs.google.com/document/d/e/2PACX-1vR1ipE3m5KnwPABTCIxTjqEoT1MX1FLFKl2lmvN3ebUJ7EBaI1daKTORPz_oISByV7QMCLz-RED7D8Z/pub" className="text-xs font-medium text-foreground hover:text-primary transition-colors border-b border-transparent hover:border-primary pb-0.5">
                  Privacy Notice
                </Link>
                <Link to="https://docs.google.com/document/d/e/2PACX-1vQrVOhz46fKlFhDPyFinYcX4GQnHJLT-FDWYrth7e0_JnyuU5V809WgCYbpocSFwHofgaCJo5RRRDxI/pub" className="text-xs font-medium text-foreground hover:text-primary transition-colors border-b border-transparent hover:border-primary pb-0.5">
                  Disclosure & Legal
                </Link>
                <Link to="https://docs.google.com/document/d/e/2PACX-1vQPIo1Kby3EIONW0vPXUpKrrYUdrs542a9QcCGYZVVw3ejt_iU_N8fckkdazWFNQZZ-6_KpMj1hZiUB/pub" className="text-xs font-medium text-foreground hover:text-primary transition-colors border-b border-transparent hover:border-primary pb-0.5">
                  Terms of Use
                </Link>
                <span className="text-[11px] text-muted-foreground">
                  © {currentYear} DynEstate®. All rights reserved.
                </span>
              </div>
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 text-[11px] text-muted-foreground">
                <span>2001 L Street N.W., Suite 500<br />Washington, DC 20036<br />United States</span>
                <span className="hidden sm:inline text-border">|</span>
                <span>+1(202) 964-4766</span>
                <span className="hidden sm:inline text-border">|</span>
                <span>capital@dynestate.com</span>
              </div>
            </div>
          </div>

          
          <div className="flex items-center gap-4 shrink-0">
            <Link to="https://twitter.com" newTab className="p-2 text-muted-foreground hover:text-foreground border border-border/50 hover:border-foreground/50 rounded-sm transition-all duration-300 group" aria-label="Twitter">
              <Twitter className="size-4 stroke-[1.5] group-hover:stroke-2" />
            </Link>
            <Link to="https://www.linkedin.com/company/dynestate/" newTab className="p-2 text-muted-foreground hover:text-foreground border border-border/50 hover:border-foreground/50 rounded-sm transition-all duration-300 group" aria-label="LinkedIn">
              <Linkedin className="size-4 stroke-[1.5] group-hover:stroke-2" />
            </Link>
            <Link to="https://dynestate.com" newTab className="p-2 text-muted-foreground hover:text-foreground border border-border/50 hover:border-foreground/50 rounded-sm transition-all duration-300 group" aria-label="Global">
              <Globe className="size-4 stroke-[1.5] group-hover:stroke-2" />
            </Link>
             <Link to="/CreditProtectionPage" className="p-2 text-muted-foreground hover:text-foreground border border-border/50 hover:border-foreground/50 rounded-sm transition-all duration-300 group" aria-label="Security">
              <ShieldCheck className="size-4 stroke-[1.5] group-hover:stroke-2" />
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}